/*
 *  Variant Selector
 *    Scripts for the Variant Selector.
 *
 *
 *  Version:
 *    1.0.0 - 2020/03/03
 */

import { jsonFromjQuery, setQueryParams } from './../../process/pc-slate-tools';

//Selectors
export const VARIANT_SELECTOR_SELECTOR = '[data-variant-selector]';
export const PRODUCT_JSON_SELECTOR = '[data-product-json]';

//Events
export const ON_VARIANT_CHANGE = 'onVariantChange';

//Errors
export const ERROR_MISSING_SELECTOR = `Could find the variant selector element!`;
export const ERROR_NO_JSON = `Attempted to load the variant selector, however there is no ${PRODUCT_JSON_SELECTOR} found on the page`;
export const ERROR_MULTIPLE_JSON = `Variant Selector found multiple ${PRODUCT_JSON_SELECTOR} elements, this could affect it's functionality.`;
export const ERROR_INVALID_JSON = `Variant Selector failed to load Product JSON!`;
export const ERROR_SELECTED_INVALID_VARIANT = `Cannot set this variant, the ID was not found in the product data!`;

//Class
export class VariantSelector {
  constructor(container, data) {
    this.container = container;

    this.selector = this.getVariantSelector();
    if(!this.selector || !this.selector.length) throw new Error(ERROR_MISSING_SELECTOR);

    this.currentId = this.selector.val();

    if(!data) {
      //Try and find the product json...
      let jsonElement = [
        () => container.find(PRODUCT_JSON_SELECTOR),
        () => container.closest(PRODUCT_JSON_SELECTOR),
        () => $(PRODUCT_JSON_SELECTOR)
      ].find(e => {
        let x = e();
        return x && x.length;
      });
      if(!jsonElement) throw new Error(ERROR_NO_JSON);
      jsonElement = jsonElement();
      if(!jsonElement || !jsonElement.length) throw new Error(ERROR_NO_JSON);
      if(jsonElement.length > 1) console.error(ERROR_MULTIPLE_JSON);

      try {
        data = jsonFromjQuery(jsonElement);
      } catch(e) {
        console.error(ERROR_INVALID_JSON);
        throw e;
      }
    }
    this.data = data;

    this.attachEvents();
  }

  shouldUseEvents() {
    return true;
  }

  getVariantSelector() {
    return this.container.find(VARIANT_SELECTOR_SELECTOR);
  }

  getProductData() {
    let p = {...this.data};
    p.variants = p.variants.map(v => ({
      ...v,
      product: p
    }));
    return p;
  }

  getSelectedVariantId() { return this.currentId; }

  getVariantData(variant) {
    if(!variant) variant = this.getSelectedVariantId();
    let v = this.data.variants.find(v => v.id == variant);
    return {...v, product: this.getProductData() };
  }

  setVariant(variantId) {
    //Find the variant that matches this ID
    let variant = this.getVariantData(variantId);
    if(!variant) throw new Error(ERROR_SELECTED_INVALID_VARIANT);

    //Update selector
    let selected = this.getSelectedVariantId();
    if(selected !== null && selected != variantId) this.selector.val(variant.id);

    //Update internal variable
    this.currentId = variant.id;

    //Fire event?
    if(this.shouldUseEvents()) {
      $(document).trigger(ON_VARIANT_CHANGE, [variant,variant.id]);

      //Update the url
      //TODO: This should become part of the product template
      let url = setQueryParams({ variant: variant.id });
      history.replaceState({ variant, variantId }, document.title, url);
    }

    this.onVariantChanged(variant, variant.id);
  }

  attachEvents() {
    this.boundVariantSelected = e => this.onVariantSelected(e);
    this.container.on('change', VARIANT_SELECTOR_SELECTOR, this.boundVariantSelected);

    if(this.shouldUseEvents()) {
      this.boundVariantChange = (e,variant,variantId) => this.onVariantChange(e, variant, variantId);
      $(document).on(ON_VARIANT_CHANGE, this.boundVariantChange);
    }
  }

  detachEvents() {
    if(this.boundVariantSelected) this.container.off('change', VARIANT_SELECTOR_SELECTOR, this.boundVariantSelected);
    if(this.boundVariantChange) $(document).off(ON_VARIANT_CHANGE, this.boundVariantChange);
  }

  onVariantSelected(e) {
    this.setVariant($(e.currentTarget).val());
  }

  onVariantChange(e, variant, variantId) {
    if(variantId == this.getSelectedVariantId()) return;
    this.setVariant(variantId);
  }

  onVariantChanged(variant, id) {
  }
}
